import { QuestionFileModel, QuestionFilePage } from 'survey-core';
import { SurveyElementBase } from 'survey-react-ui';
import classNames from 'classnames';

import { SurveyFilePreviewItem } from '../SurveyFilePreviewItem/SurveyFilePreviewItem';

import styles from '../SurveyFilePreview.module.scss';

export class SurveyFilePreviewPage extends SurveyElementBase<
  { question: QuestionFileModel; page: QuestionFilePage },
  {}
> {
  protected get question(): QuestionFileModel {
    return this.props.question;
  }

  protected get page(): any {
    return this.props.page;
  }

  protected renderElement(): JSX.Element | null {
    const items = this.page.items.map((item: any, index: number) => {
      return (
        <SurveyFilePreviewItem
          item={item}
          question={this.question}
          key={index}
        ></SurveyFilePreviewItem>
      );
    });

    return (
      <div className={classNames(this.page.css, styles.page)} id={this.page.id}>
        {items}
      </div>
    );
  }
}
